import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_mst_item_hdr_RowClass} from '../../../dbschema/bl_inv_mst_item_hdr.model';
import {bl_inv_mst_item_line_RowClass} from '../../../dbschema/bl_inv_mst_item_line.model';
import {bl_inv_mst_item_ext_RowClass} from '../../../dbschema/bl_inv_mst_item_ext.model';
import {ExtQueryCriteria} from '../../ExtQueryCriteria';

export class InventoryItemContainerModel extends BaseContainerModel {
  bl_inv_mst_item_hdr: bl_inv_mst_item_hdr_RowClass = new bl_inv_mst_item_hdr_RowClass();
  bl_inv_mst_item_exts: bl_inv_mst_item_ext_RowClass[] = [];
  bl_inv_mst_item_lines: bl_inv_mst_item_line_RowClass[] = [];
}

export class InventoryItemQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;

  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  exts: ExtQueryCriteria[] = [];
}


